import { applyMiddleware, legacy_createStore as createStore } from "redux";
import reducers from "services/redux/reducers";
import dataMiddleware from "services/redux/data/middleware";
import cartMiddleware from "services/redux/cart/middleware";
import { getCache, setCache } from "services/redux/state-cache";
import HelperDevelopment from "utils/helper-development";

const cache = getCache();

const store = createStore( reducers,
	applyMiddleware(
		dataMiddleware,
		cartMiddleware,
	)
);

if( HelperDevelopment.isDev() ) {
	store.subscribe(() => {
		return setCache(store.getState());
	} );
}

export default store;
